/**
 * Phase 6c — Mobile Executive Alert Banner
 * Renders only on mobile (md:hidden). Max 2 CRITICAL/persistent-WARNING.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle, AlertOctagon } from "lucide-react";

const SEV_STYLE = {
  CRITICAL: { bg: "bg-rose-600 text-white", icon: AlertOctagon },
  WARNING:  { bg: "bg-amber-500 text-white", icon: AlertTriangle },
};

export default function MobileExecutiveAlertBanner() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/executive/mobile-alert-banner")
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]));
  }, []);
  if (items.length === 0) return null;
  return (
    <div className="md:hidden space-y-2" data-testid="mobile-exec-alert-banner">
      {items.map((it) => {
        const S = SEV_STYLE[it.severity] || SEV_STYLE.WARNING;
        const Icon = S.icon;
        return (
          <div key={it.id} className={`rounded-md ${S.bg} px-3 py-2 shadow-sm`}
                data-testid={`mobile-alert-${it.id}`}>
            <div className="flex items-start gap-2">
              <Icon className="h-4 w-4 flex-shrink-0 mt-0.5" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-[10px] font-bold uppercase tracking-wide">{it.severity}</span>
                  <span className="text-[11px] font-semibold truncate">{it.title}</span>
                  {it.acknowledged && (
                    <span className="text-[9px] bg-white/20 px-1.5 py-0.5 rounded">Sudah dikonfirmasi</span>
                  )}
                </div>
                <div className="text-[11px] mt-0.5 line-clamp-2">{it.message}</div>
                <div className="flex items-center gap-3 text-[10px] mt-1 opacity-90">
                  <span>Nilai: {it.value}</span>
                  <span>Threshold: {it.threshold}</span>
                  <span>Durasi: {it.duration_hours} jam</span>
                </div>
                {it.drill_to && (
                  <Link to={it.drill_to} className="inline-block text-[11px] mt-1.5 underline font-semibold"
                         data-testid={`mobile-alert-link-${it.id}`}>
                    Lihat Detail
                  </Link>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
